module.exports = __webpack_public_path__ + "files/579df3027fee76eb884c5bd7912bf04e.png";